import React from "react";
import { Text } from "@fluentui/react";
import ClientDropdown from "../Forms/ClientDropdown";
import CobrandTagsDropdown from "../Forms/CobrandTagsDropdown";
import CobrandDropDown from "../Forms/CobrandDropDown";

const OnOffSettingsFields = ({setOptionTable}) => {
  return (
    <>
      <Text variant="small">
        Select the clients, cobrand tags, or cobrands below to turn this checklist on for them.
      </Text>
      <ClientDropdown
        name={"client"}
        label="ON for Clients"
        multiSelect
        setOptionTable={setOptionTable}
      />
      <CobrandTagsDropdown
        name="cobrandTag"
        label="ON for Cobrand Tags"
        setOptionTable={setOptionTable}
        multiSelect
      />
      <CobrandDropDown
        name={"cobrand"}
        label="ON for Cobrand"
        byNameOrId="id"
        setOptionTable={setOptionTable}
        multiSelect
      />
    </>
  );
};

export default OnOffSettingsFields;
